module.exports = __webpack_public_path__ + "img/hr-artillery-wagon-base-13.7b18017e.png";